import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LockIcon from '@mui/icons-material/Lock';
import {
  AccordionDetails,
  AccordionSummary,
  CardHeader,
  SxProps,
  Theme,
} from '@mui/material';
import React from 'react';
import { AnimatedAccordion } from '../../../MotionMui/MotionMui';

export interface WorldTourCardProps {
  defaultExpanded: boolean | undefined;
  contentId: string | undefined;
  subHeader: any;
  sx?: SxProps<Theme>;
  headerSx?: SxProps<Theme>;
  disabled?: boolean;
  header: any;
  avatar?: any;
  children: any;
  id: any;
}

export const WorldTourCard = (props: WorldTourCardProps) => {
  return (
    <AnimatedAccordion
      disabled={props.disabled}
      sx={props.sx}
      defaultExpanded={props.defaultExpanded}
      disableGutters
    >
      <AccordionSummary
        expandIcon={props.disabled ? <LockIcon /> : <ExpandMoreIcon />}
        aria-controls={props.contentId}
        id={props.id}
        sx={{
          ...props.sx,
          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0,
          },
          // Add styles for the disabled state
          '&.Mui-disabled': {
            // Target the AccordionSummary root when disabled
            filter: 'grayscale(80%)', // Apply grayscale filter
            opacity: 0.8, // Override the default MUI disabled opacity
            backgroundColor:
              (props.sx ?? ({} as any)).backgroundColor ?? 'white',
          },
        }}
      >
        <CardHeader
          avatar={props.avatar}
          title={props.header}
          subheader={props.subHeader}
          sx={props.headerSx}
        />
      </AccordionSummary>
      <AccordionDetails>{props.children}</AccordionDetails>
    </AnimatedAccordion>
  );
};
